import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import map from "../../../../assets/images/map.svg";

function Hero() {
  let letterRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Get all the letter elements inside letterRef
    const letters = letterRef.current.querySelectorAll("[data-char]");

    // Animate each letter from the top to its position
    gsap.fromTo(
      letters,
      {
        y: -50, // animate from 50px above
        opacity: 0,
      },
      {
        y: 0, // animate to original position
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: letterRef.current,
          start: "top 75%",
        },
      }
    );
  }, []);

  const data = [
    { title: "support", desc: "Our Friendly team is here to help.", address: "contact@synswift.com", color: "#b67aff" },
    { title: "Phone", desc: "Mon-Fri 8AM to 7PM", address: "+91 768 780 4000", color: "#fdc735" },
    { title: "Location", desc: "Visit our office", address: "Ground Floor, Nasib Tower, D-266, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit Singh Nagar, Punjab 140307", color: "#f49152" },
  ];

  return (
    <div className="md:pt-20 pt-0 p-4 overflow-hidden relative container mx-auto">
      <div className="lg:flex flex-row">
        <div className="flex flex-row z-10 lg:gap-4 gap-0 px-4 lg:px-0 items-start text-left">
          <div className="w-1 mt-2 h-9 bg-primaryColor"></div>
          <div className="flex flex-col gap-1 items-start">
            <span className="lg:text-5xl text-2xl font-bold text-fontPrimary leading-normal">
              Let's build something
            </span>

            <div>
              <h3
                className="flex flex-row  gap-1 overflow-hidden lg:text-5xl text-2xl pb-2 leading-relaxed font-bold text-primaryColor"
                ref={letterRef}
              >
                <div data-char="t">t</div>
                <div data-char="o">o</div>
                <div data-char="g">g</div>
                <div data-char="e">e</div>
                <div data-char="t">t</div>
                <div data-char="h">h</div>
                <div data-char="e">e</div>
                <div data-char="r">r</div>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center py-16">
        <img className="w-10/12" src={map} alt="map.png" />
      </div>

      <div className="flex md:flex-row flex-col gap-8">
        {data.map((item, index) => (
          <div key={index} className="flex flex-1 flex-col gap-2">
            <h1 className="text-xl font-medium" style={{ color: item.color }}>{item.title}</h1>
            <p className="font-semibold text-fontPrimary">{item.desc}</p>
            <span className="text-fontPrimary">{item.address}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Hero;
